import axios from 'axios';
import _ from 'lodash';
import { apiBase } from '../config/apiBase';
import { auths, callAirBrake, headerNoAuths, headers, url } from '../config/apiSetting';
import {
  CHANGE_THEME,
  ERROR_MSG,
  GET_ERRORS,
  HIDE_LOADING_SPINNER,
  INVALID_PIN,
  LOGOUT,
  PIN_SEND,
  PIN_VERIFY,
  SUCCESS_MSG,
} from '../constants/actionTypes';
import { settingDark } from '../helpers/translations/cssClassHelper';
import { clearLS, getLS, removeLS, setLS } from '../helpers/utils';

export const loginPin = (data) => (dispatch) => {
  const user = {
    user: { msisdn: data.msisdn, pin: data.pin, operator: data.operator },
  };

  return axios
    .post(`${url}/users/sign_in_msisdn`, user, {
      withCredentials: true,
      headers: headerNoAuths,
    })
    .then((res) => {
      if (!res.data.error) {
        if (res.data.success) {
          setLS('header_token', JSON.stringify(res.data));
          setLS('dark', false);
          if (res.data.locales) {
            if (res.data.locales.length > 1) {
              setLS('defaultLang', res.data.locales[1]);
            } else {
              setLS('defaultLang', res.data.locales[0]);
            }
          } // set to en
          // eslint-disable-next-line brace-style
          else {
            setLS('defaultLang', 'en');
          }

          dispatch({ type: PIN_VERIFY, payload: SUCCESS_MSG });
          dispatch({ type: GET_ERRORS, payload: '' });
        } else {
          dispatch({ type: GET_ERRORS, payload: ERROR_MSG });
          dispatch({ type: PIN_VERIFY, payload: ERROR_MSG });
        }
      } else {
        dispatch({ type: GET_ERRORS, payload: ERROR_MSG });
        dispatch({ type: PIN_VERIFY, payload: ERROR_MSG });
      }
    })
    .catch((err) => {
      dispatch({ type: GET_ERRORS, payload: ERROR_MSG });
    });
};

export const loginMobile = (data) => (dispatch) => {
  const url = apiBase;
  const { msisdn } = data;
  const { country } = data;
  const { operator } = data;

  return axios
    .post(`${url}/pin`, null, {
      params: { msisdn, operator },
      auth: auths,
      headers,
    })
    .then((res) => {
      if (!res.data.error) {
        dispatch({ type: PIN_SEND, payload: SUCCESS_MSG });
        setLS('msisdn', msisdn);
        setLS('operator', operator);
      } else {
        dispatch({ type: GET_ERRORS, payload: ERROR_MSG });
        callAirBrake(`MSISDN=${msisdn} not found`);
      }
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: ERROR_MSG,
      });
    });
};

export const logoutUser = (history) => (dispatch) => {
  const headerConfig = JSON.parse(getLS('header_token'));
  settingDark(getLS('dark'));

  if (headerConfig) {
    return axios
      .delete(`${url}/users/sign_out_msisdn`, { withCredentials: true })
      .then((data) => {
        removeLS('msisdn');
        removeLS('operator');
        removeLS('header_token');
        removeLS('defaultLang');
        removeLS('isActive');

        const checkExistingLocalStorage = JSON.parse(getLS('unsubDatas'));
        if (!_.isEmpty(checkExistingLocalStorage)) {
          removeLS('unsubDatas');
        }
        dispatch({ type: LOGOUT, payload: 'logout' });
        // swal( "You have successfully logged out." );
        history.push('/login');
      })
      .catch((err) => {
        // handle error
        // Just force to sign in again
        dispatch({ type: LOGOUT, payload: 'logout' });
        clearLS();
        history.push('/login');
      });
  }
  dispatch({ type: LOGOUT, payload: 'logout' });
  clearLS();
  history.push('/login');
};

export function changeTheme(data) {
  return {
    type: CHANGE_THEME,
    payload: data,
  };
}
